import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "./AuthContext";
import { serverHost } from "../config";
import { ShoppingCart } from "lucide-react";

export const Login: React.FC = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate("/dash");
    }
  }, [user, navigate]);

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      const response = await fetch(`${serverHost()}/api/v1/auth/google`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });

      if (!response.ok) {
        throw new Error("Failed to authenticate with Google");
      }

      const data = await response.json();
      login(data.token);
      navigate("/dash");
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="p-3 bg-blue-600 rounded-xl shadow-lg">
              <ShoppingCart className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">MyMarket</h1>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6 text-center">
            <h2 className="text-2xl font-bold text-white mb-2">
              Bem-vindo de volta!
            </h2>
          </div>

          <div className="p-8">
            <div className="space-y-6">
              <div className="text-center">
                <p className="text-gray-600 mb-6">
                  Use o Google para fazer login ou se cadastrar
                </p>
              </div>

              <div className="text-center">
                <div className="inline-block">
                  <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={() => console.log("Login Failed")}
                    useOneTap
                    theme="outline"
                    size="large"
                    text="signin_with"
                    shape="rectangular"
                  />
                </div>
              </div>

              <div className="text-center">
                <p className="text-sm text-gray-500">
                  Ao se cadastrar, você concorda com nossos{" "}
                  <a
                    href="/dash/login"
                    target="_blank"
                    className="text-blue-600 hover:text-blue-700 font-medium"
                  >
                    termos de uso
                  </a>{" "}
                  e{" "}
                  <a
                    href="/dash/login"
                    target="_blank"
                    className="text-blue-600 hover:text-blue-700 font-medium"
                  >
                    política de privacidade
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
